import queryString from "query-string";
import { useEffect, useState } from "react";

import { Loader } from "../../components";
import { useAxios, useComponent } from "../../hooks";
import Form from "./dynamic ui details components/Form";
import {
  dynamicUiObjects,
  objectFromResponse,
} from "./dynamic ui details components/dynamicUiObjects";
import PermissionSettings from "../permission component/PermissionSettings";

export default function DynamicUI() {
  const axios = useAxios();
  const { loader } = useComponent();
  const [editState, setEditState] = useState(false);
  const [formData, setFormData] = useState(dynamicUiObjects);
  const [editStatePermission, setEditStatePermission] = useState(false);

  const platformID = queryString.parse(window.location.search).platform_id;

  useEffect(() => {
    loader.start();
    let url = "get/dynamicDashboard/" + platformID;
    if (platformID === "Verismart") {
      url = "get/dynamicDashboard";
    }
    axios({
      url: url,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setFormData(objectFromResponse(response.data));
        loader.stop();
      }
    });
  }, [axios, loader, platformID]);

  return (
    <Loader>
      <Form
        platformID={platformID}
        formData={formData}
        setFormData={setFormData}
        editState={editState}
        setEditState={setEditState}
      />

      <PermissionSettings
        platformID={platformID}
        editState={editStatePermission}
        setEditState={setEditStatePermission}
      />
    </Loader>
  );
}
